function NXProductFilter() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 6H10.5"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12H12.5"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 12H21.5"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 6L21.5 6"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 18H20.5"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 18H6.5"
        stroke="#110D06"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.5" cy="18" r="2" stroke="#110D06" strokeWidth="1.5" />
      <circle cx="17.5" cy="12" r="2" stroke="#110D06" strokeWidth="1.5" />
      <circle cx="12.5" cy="6" r="2" stroke="#110D06" strokeWidth="1.5" />
    </svg>
  );
}

export default NXProductFilter